import Modules from '@app/modules';
Modules.register({
    namespace: 'RF/Member',
    taggedComponents: {
        nav: [
            function () { return import(/* webpackChunkName: "MemberFrontNav" */ '@app/modules/RF/Member/FrontNav.vue'); }
        ]
    }
});
